module.exports = __webpack_public_path__ + "preview-eac7acfc/ibm-plex-sans-regular-ef6a33f2b85b9c104bde0f4f1eb64008.woff";